import $ from "jquery";
import bdjs from "@bd-core/bdjs";
// import bdapi from "@bd-core/bd-api";
import CONFIG from "@bd-core/config";
import getFileExtension from "@bd-utils/getFileExtension";
import axios from "axios";
import CFG from "@bd-core/config";

export const SetupAvatarPage = () => {
    const isSetupAvatarPage = $("#page-setupavatar").length > 0;

    if (!isSetupAvatarPage) return;

    bdjs.hideLoading();

    $(".app__brand").find(".invert").css("display","block");
    $(".app__brand").find(".normal").css("display","none");

    const elms = {
        inputNickname: ".js-nickname",
        avatarList: ".js-avatar-list",
        avatar: ".js-avatar",
        avatarUpload: ".js-avatar-upload",
        avatarUploadBtn: ".js-avatar-upload-button",
        uploadPreview: ".js-upload-preview",
        continueBtn: ".js-continue",
    };

    /**
     * Get relative path of a url without the site / hostname
     *
     * @param {string} url
     */
    const getRelativeUrl = (url) => {
        const site = CONFIG.siteURL;
        return url.replace(site, "");
    };

    /**
     * Get avatar url base on given id, will return undefined if not found
     *
     * @param {number} id
     */
    const getAvatarUrl = (id) => CONFIG.avatarOptions[id];

    const validateFile = (file) => {
        const validExtensions = ["jpg", "png", "jpeg"];
        const allowed = validExtensions.join(",");
        const extension = getFileExtension(file);
        const isValid = validExtensions.includes(extension);
        const message = window.CFG?.strings.allowedFile;

        if (!isValid) {
            showSnackbarMessage(`${message} ${allowed}`);
            return false;
        }

        return true;
    };

    const setUploadPreview = (file) => {
        const url = window.URL.createObjectURL(file);

        $(elms.avatarList).find(elms.avatar).prop("checked", false);
        $(elms.uploadPreview).parent().removeClass("hidden");
        $(elms.uploadPreview)
            .parent()
            .find(elms.avatar)
            .prop("checked", true)
            .addClass("is-selected");
        $(elms.uploadPreview).attr("src", url);
    };

    const onClickUploadBtn = () => {
        const $uploadInput = $(elms.avatarUpload);

        $uploadInput.trigger("click");
    };

    // on upload avatar
    const onFileChange = function (e, data) {
        const $this = $(this);
        const file = $this[0].files[0];
        const isValid = validateFile(file);

        if (!isValid || !data) {
            const theAvatar = $(elms.avatarList).attr("data-avatar");

            const $avatars = $(elms.avatar);
            const $avatar = $avatars.filter(`[data-avatar="${theAvatar}"]`);

            if ($avatar.length) {
                $avatar.addClass("is-selected");
            } else {
                $avatars.first().addClass("is-selected");
            }
        }

        setUploadPreview(file);
    };

    // on select provided avatar
    const onAvatarSelect = function () {
        const $this = $(this);
        const avatarWrapper = $this.parents(elms.avatarList);
        avatarWrapper
            .find(elms.avatar)
            .removeClass("is-selected");

        $(elms.avatarUpload).val("");

        $this.addClass("is-selected");
    };

    const validateName = (name) => {
        const testString = /<\/?[a-z][\s\S]*>/i.test(name); // check if the string contain html tag
        let isValid = false;
        if (name.length > 0 && !testString) {
            isValid = true;
        }

        return isValid;
    };

    // on submit profile
    let isLoading = false;
    const onSubmitProfile = async function (e) {
        e.preventDefault();

        const $button = $(e.currentTarget);
        // const user = getUserFromId(CONFIG.user.id);
        const avatarImg = Number(
            $(`${elms.avatar}.is-selected`).attr("data-avatar"),
        );

        const default_avatar = CONFIG.default_avatar;
        const setAvatarImg = isNaN(avatarImg)
            ? default_avatar
            : getAvatarUrl(avatarImg);

        const name = String($(elms.inputNickname).val()).trim();
        const nickname = name
            .replace(/&/g, "&amp;")
            .replace(/</g, "&lt;")
            .replace(/"/g, "&quot;");
        const isNameValid = validateName(name);

        /**
         * @type {JQuery<HTMLInputElement>}
         */
        const $customAvatar = $(elms.avatarUpload);
        const customAvatar = $customAvatar[0].files[0];
        // const isUploadAvatar = !avatarImg && customAvatar;

        if (isLoading) return;

        $button.addClass("is-loading").prop("disabled", true);

        const unsetLoading = () => {
            $button.removeClass("is-loading").removeAttr("disabled");
        };

        if (!isNameValid) {
            unsetLoading();
            showSnackbarMessage("Nickname cannot be empty");
            return;
        }

        var formData = new FormData();
        formData.append("hasSetupProfile", "1");
        formData.append("name", nickname);
        formData.append("isCustomAvatar", customAvatar ? "1" : "0");
        formData.append("avatarURL", getRelativeUrl(setAvatarImg));
        formData.append("custom_avatar", customAvatar);
        

        const [res] = await bdjs.goAsync(
            // bdapi.post("member/submit-player-profile", updateData),
            axios.post(
                `${CFG.restURL}/member/submit-player-profile`,
                formData,
                {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                },
            ),
        );

        const restData = res?.data || {};

        if (restData?.data?.redirect) {
            bdjs.showLoading();
            window.location.href = restData.data.redirect;
            return;
        } else if (restData.data?.msg) {
            showSnackbarMessage(restData.data.msg);
            unsetLoading();
            return;
        }
    };

    const showSnackbarMessage = (text) => {
        const $snackbar = $(".snackbar");
        $snackbar.find(".js-snackbar-body").html(text);
        $snackbar.addClass("is-active");
    };

    const $snackBar = $(".snackbar");
    $snackBar.find(".js-snackbar-close").on("click", function (e) {
        e.preventDefault();
        $snackBar.removeClass("is-active");
    });

    $(document).on("click", elms.avatarUploadBtn, onClickUploadBtn);
    $(document).on("click", elms.avatar, onAvatarSelect);
    $(document).on("change", elms.avatarUpload, onFileChange);
    $(document).on("click", elms.continueBtn, onSubmitProfile);
};
